<template>
  <div class="app-buttons">
    <div v-if="item.statusKey === 'SUS'" class="btn-deactivate">
    <b-button  :disabled="loading_"  @click="openTopUpAccordion">
          <slot name="btnBalance">Guthaben aufladen</slot>
        </b-button>
    </div>
    <b-overlay v-if="isDeactivable"  class="btn-next-overlay btn-deactivate" :show="loading_" spinner-small>
        <b-button :disabled="loading_"  @click="deactivateOption">
          <slot name="btnDeactivate">Deaktivieren</slot>
        </b-button>
    </b-overlay>
  <div class="btn-deactivate" v-if="item.isPendingTariff">
        <b-button :disabled="loading_"  @click="cancelTariff">
          <slot name="btnCancel">Stornieren</slot>
        </b-button>
  </div>
    <div class="btn-deactivate" v-if="showChange">
        <b-button  :disabled="loading_"  @click="openTariffsAccordion">
          <slot name="btnManage">Verwalten</slot>
        </b-button>
    </div>
  </div>
</template>
<script>

import { BButton } from 'bootstrap-vue'
import { mapMutations } from 'vuex'

export default {
  name: 'Buttons',
  components: { BButton },
  data () {
    return {
      visible: false,
      loading: false
    }
  },
  methods: {
    ...mapMutations('tariffs', [
      'changeView',
      'resetState'
    ]),
    setStep (view) {
      this.changeView({ view: view })
    },
    deactivateOption () {
      this.resetState()
      this.$emit('selected')
    },
    changeLoading (loading) {
      this.loading = loading
    },
    cancelTariff () {
      this.resetState()
      this.$emit('selected')
    },
    openMyFyveOverview () {
      this.$emit('refresh')
      this.setStep('overview')
    },
    openTariffsAccordion () {
      document.dispatchEvent(new CustomEvent('accordion-tariffOptions', { detail: { type: 'open', scrollIntoView: true } }))
    },
    openTopUpAccordion () {
      document.dispatchEvent(new CustomEvent('accordion-singleTopUp', { detail: { type: 'open', scrollIntoView: true } }))
    }
  },
  computed: {
    loading_: function () {
      return this.loading
    },
    isDeactivable: function () {
      return (!this.item.isPendingTariff && this.item.cancelable) || this.itemType === 'serviceOption'
    },
    showChange: function () {
      return this.itemType !== 'serviceOption'
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    itemType: {
      type: String,
      required: true
    }
  }
}
</script>
